import { useUpdateCurrentUser } from '@bizzabo/entities';
import useProfileAnalytics from './useProfileAnalytics';

type UseHideProfileToggleProps = (
    eventId?: number,
    userProfileId?: number
) => (isHidden: boolean) => void;

const useHideProfileToggle: UseHideProfileToggleProps = (eventId, userProfileId) => {
    const updateCurrentUser = useUpdateCurrentUser();
    const { sendHideProfile } = useProfileAnalytics();

    const changeIsProfileHidden = (isHidden: boolean) => {
        updateCurrentUser({
            eventId,
            userProfileId,
            payload: { isHidden },
        });

        sendHideProfile(isHidden);
    };

    return changeIsProfileHidden;
};

export default useHideProfileToggle;
